import { Box, Button, Grid2, Typography } from "@mui/material"
import { useAdminAttendaceList, useApartmentListForCourse, useCourseApartmentDetail } from "../../assets/api/useAdminApi"
import { NormalContainerWithHeader } from "../../shared/components/student/NormalComponent";
import { IdAutoCompleteField } from "../../shared/components/formfields/IdAutoCompleteField";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import CustomDivider from "../../shared/utils/CustomDivider";
import { Grid_Gap } from "../../shared/constants";
import { DateFormField } from "../../shared/components/formfields/DataFormField";
import { DataGrid } from "@mui/x-data-grid";
import CustomPagination from "../../shared/utils/CustomPagination";
import DataGridSkeleton from "../../shared/components/DataGridSkeleton";
import useAuthStore from "../../store/useAuthStore";


const CommonCheckAttendance = () => {
    const { user } = useAuthStore()
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [selectedApartment2, setSelectedApartment2] = useState({})
    const [filter, setFilter] = useState(null)
    const { data: courselist2, isLoading: isLoading2 } = useCourseApartmentDetail({ apartments_id: selectedApartment2?.id })
    const { data: attendacelist, isLoading: isAttendanceLoading } = useAdminAttendaceList({ course_id: filter?.course_id, apartment_id: filter?.apartment_id, from_date: filter?.from_date, to_date: filter?.to_date })
    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    const ApartmentOptions = apartmentList?.data?.map((item) => ({
        id: item?.id,
        label: item?.apartment_name,
        value: item?.apartment_name,
    })) || [];
    const CourseOptions2 = courselist2?.map((item) => ({
        id: item?.course_id,
        label: item?.course_name,
        value: item?.course_name,
    })) || [];
    const validationSchema2 = Yup.object().shape({
        apartment_id: Yup.string()
            .required("Apartment is required"),

        course_id: Yup.string()
            .required("Course is required"),

        from_date: Yup.date()
            .required("From date is required"),

        to_date: Yup.date()
            .required("To date is required")
    });;
    const initialValues2 = {
        apartment_id: user.role === "organizer" ? user?.apartment_id : "",
        course_id: "",
        from_date: "",
        to_date: ""
    };
    const handleSubmit2 = (values, { resetForm }) => {
        setFilter(values)
        resetForm()
    }

    const attendanceColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "lastname",
            headerName: "Student Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "event_title",
            headerName: "Course Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value} </Typography>,
        },
        {
            field: "attendance_date",
            headerName: "Attendance Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value} </Typography>,
        },
        {
            field: "remarks",
            headerName: "Remark",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value} </Typography>,
        },
        {
            field: "attendance_status",
            headerName: "Attendance Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" color={params.value === 1 ? "success.main" : "error.main"
            } > {params.value === 1 ? "Present" : "Absent"} </Typography >,
        },

    ];
    const attendanceRows = attendacelist?.map((item, index) => ({
        id: item?.id || index + 1,
        sr_no: index + 1,
        ...item
    })) || [];


 useEffect(() => {
        if (user.role === "organizer") {
            setSelectedApartment2({ id: user?.apartment_id })
        }
    }, [user?.role, user?.apartment_id , user])

    return (
        <NormalContainerWithHeader headerText={"Check Attendance"}>
            <Formik initialValues={initialValues2} enableReinitialize validationSchema={validationSchema2} onSubmit={handleSubmit2}>
                {({ values }) => (
                    <Form>
                        <Grid2 container spacing={Grid_Gap}>
                            <Grid2 size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="apartment_id"
                                    component={IdAutoCompleteField}
                                    options={ApartmentOptions}
                                    label="Select Apartment"
                                    isLoading={isLoadingApartmentList}
                                    onValueChange={(val) => {
                                        setSelectedApartment2(val)
                                    }}
                                    disabled={user.role === "organizer"}

                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="course_id"
                                    component={IdAutoCompleteField}
                                    options={CourseOptions2}
                                    label="Select Course"
                                    isLoading={isLoading2}

                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="from_date"
                                    component={DateFormField}
                                    label="Select From Date"
                                    maxDate={values.to_date || undefined}

                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="to_date"
                                    component={DateFormField}
                                    label="Select To date"
                                    minDate={values.from_date || undefined}

                                />
                            </Grid2>
                        </Grid2>
                        <CustomDivider />
                        <Grid2 container sx={{ placeContent: "flex-end" }}>
                            <Grid2 size={{ xs: 12, sm: 4 }}>
                                <Button variant="contained" type="submit" fullWidth>View</Button>
                            </Grid2>
                        </Grid2>

                    </Form>)}
            </Formik>
            <CustomDivider />
            {
                filter && <>
                    {isAttendanceLoading ? (
                        <DataGridSkeleton rowsNum={10} />
                    ) : (
                        <DataGrid
                            rows={attendanceRows}
                            columns={attendanceColumn}
                            pagination
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                            pageSizeOptions={[10]}
                            disableRowSelectionOnClick={true}
                            slots={{
                                pagination: () => (
                                    <CustomPagination
                                        paginationModel={paginationModel}
                                        setPaginationModel={setPaginationModel}
                                        totalRows={attendanceRows?.length || 0}
                                        pageSize={paginationModel.pageSize}
                                    />
                                ),
                            }}
                        />
                    )}
                </>
            }

        </NormalContainerWithHeader>
    )
}

export default CommonCheckAttendance